import HelpSupportPage from "pages/HelpSupportPage";
import React from "react";

const HelpSupportRoute = () => <HelpSupportPage />;

export default HelpSupportRoute;
